/**
 * Parse a MetaBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed MetaBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function meta(view) {
    return view.readFullBox();
}
;
//# sourceMappingURL=meta.js.map